import React, { useEffect, useState } from 'react';
import FormRadioButton from './FormRadioButton';

function RadioButtonGroup({ name, id, options, onChange, customError, errId, isRequired, value }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [radioOptions, setRadioOptions] = useState([]);

  useEffect(() => {
    if(options && options.length > 0){
      setRadioOptions(options);
    }else{
      // setRadioOptions(["Yes", "No"]);
    }
  },[options])

  useEffect(() => {
    if(value){
      setSelectedOption(value);
    }
    if(name == 'form16'){
      setSelectedOption(value);
    }
  },[value])

  const handleChange = (index, id, selectedOption, option) => {
    setSelectedOption(option);
    onChange(index, id, selectedOption, option, name, errId); // Notify parent component about the change
  };

  return (
    <>
    <div className="radio-button-group d-flex justify-content-start">
      {radioOptions.map((option, index) => (
        <FormRadioButton
          key={index}
          label={`${option}`}
          isChecked={selectedOption === option}
          onChange={() => handleChange(index, id, selectedOption, option)}
          />
        ))}
            {/* <label htmlFor={id ? id : ''} className={'focused'} style={labelStyle}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label> */}

    </div>
        {
          customError?<p className="err text-danger">This field is required.</p> : <p className="err text-danger" id={errId}></p> 
        } 
     </>   
  );
}

export default RadioButtonGroup;
